import acordeon from "./lib/aria/acordeon";

const toggles = () => acordeon('.toggle', true)

export default toggles;